<template>
  <div>
    <b-table
      :items="visibleItems"
      :fields="fields"
      small
      class="bordered table-no-minheight"
      show-empty
      :empty-text="$t('Nenhuma linha cadastrada. Os produtos associados usam a classificação fiscal do NCM.')"
      responsive
      striped
    >
      <template #cell(actions)="{ item }">
        <e-grid-actions
          v-if="canEdit"
          :show-update="true"
          :show-delete="true"
          @update="$emit('update-item', item)"
          @delete="$emit('delete-item', item)"
        />
        <span v-else>-</span>
      </template>
    </b-table>

    <b-row class="mt-1">
      <b-col
        md="12"
        class="text-right"
      >
        <e-button
          v-if="canEdit"
          variant="primary"
          icon="plus-circle"
          :text="$t('Adicionar Exceção Fiscal')"
          @click="$emit('add-item')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BTable, BRow, BCol } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { EGridActions, EButton } from '@/views/components'

export default {
  name: 'TaxConfigurationGroupItemTable',
  components: {
    BTable, BRow, BCol, EButton, EGridActions,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'actions',
          label: this.$t('Ações'),
          thStyle: 'width: 100px;',
          tdClass: 'text-center',
        },
        {
          key: 'state',
          label: this.$t('UF de Origem'),
          formatter: value => value || this.$t('Todas'),
        },
        {
          key: 'operationType',
          label: this.$t('Operação'),
          formatter: value => this.operationTypeLabel(value),
        },
        {
          key: 'destinationState',
          label: this.$t('UF Destino'),
          formatter: value => value || '-',
        },
        { key: 'cfopOutput', label: this.$t('CFOP Saída') },
        {
          key: 'stIcms',
          label: this.$t('CST ICMS'),
          formatter: (value, key, item) => value || item.csosnIcms || '-',
        },
        {
          key: 'icmsPercent',
          label: this.$t('% ICMS'),
          formatter: value => this.percent(value),
        },
        {
          key: 'stPisOutput',
          label: this.$t('CST PIS'),
          formatter: value => value || '-',
        },
        {
          key: 'stCofinsOutput',
          label: this.$t('CST COFINS'),
          formatter: value => value || '-',
        },
        {
          key: 'benefitCode',
          label: this.$t('Cód. Benefício'),
          formatter: value => value || '-',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('pages/invoice/taxConfigurationGroups/taxConfigurationGroupMaintain', [
      'visibleItems',
    ]),

    canEdit() {
      return !this.readOnly && this.$can('Update', 'TaxConfigurationGroup')
    },
  },
  methods: {
    /** O valor é fração no store (0.18) e percentual na tela (18%). */
    percent(value) {
      return value == null ? '-' : `${(value * 100).toFixed(2)}%`
    },
    operationTypeLabel(value) {
      switch (value) {
        case 'INTERSTATE':
          return this.$t('Interestadual')
        case 'EXTERIOR':
          return this.$t('Exterior')
        default:
          return this.$t('Interna')
      }
    },
  },
}
</script>

<style scoped></style>
